import moment from "moment";
import iconEdit from "../../../../../assests/editForm.png";
import CalendarEventPopup from "../calendarEventPopup/CalendarEventPopup";
import MyTooltipComponent from "../../../ui/myTooltipComponent/MyTooltipComponent";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import classes from "./Templates.module.css";

const DayEventTemplate = (props) => {

    return (
        <MyTooltipComponent offsetY={-10} offsetX={-250} Content={() => <CalendarEventPopup {...props} calendarType="FullCalendar" />}>
            <div className={classes.DayEventWrapper}>
                <div className={`${classes.Event} ${classes.DayEvent} ${props.IsAllDay && classes.WeekAllDayEvent} ${props.holiday ? classes.Holiday : null}`}
                    style={{
                        borderColor: props.holiday ? "#53C8E1" : props.domainColor,
                        backgroundColor: props.holiday ? "#53C8E133" : props.IsAllDay ? `${props.DomainColor}33` : !props.IsAllDay && "white"
                    }} >
                    <div className={classes.DayWrapSubject}>
                        <div className={classes.Subject}>{props.Subject}</div>
                        {!props.IsAllDay &&
                            <div className={classes.Time}>
                                {`${moment(props.EndTime).format('HH:mm')} - ${moment(props.StartTime).format('HH:mm')}`}
                            </div>}
                    </div>
                    {!props.IsAllDay && <div className={classes.WeekEventLogo} style={{ backgroundImage: `url(${props.ProviderLogo})` }} />}
                    {props.isAssessment && <AccessibilityHiddenImg className={classes.IconEdit} src={iconEdit} />}
                </div>
            </div >
        </MyTooltipComponent>

    )
}

export default DayEventTemplate;